<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Celebrations</h4>
                  <div class="card-body">
                    <p class="inner-lead">At our school, we believe that celebrating special occasions and events is a significant part of building a strong and supportive community. We have a wide range of celebrations throughout the year that brings students, families, and staff together to share in the joy and excitement of these special moments.</p>
                    <p class="inner-lead">Our school has a vibrant and dynamic community that is strengthened by our celebration of special occasions and events. From religious holidays to cultural festivals, we recognize the importance of celebrating diversity and fostering a sense of belonging. Our school events provide opportunities for students to learn about different cultures, traditions, and values. These celebrations also allow students to showcase their talents, creativity, and cultural heritage.

                    </p>
                    <p class="inner-lead">We believe that celebrating special occasions and events is not only a way to bring our community together, but also an opportunity to teach our students important life skills such as teamwork, collaboration, leadership, and communication. These skills will serve our students well in their future endeavors and help them become successful, well-rounded individuals.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>